import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpMethod, HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import { Endpoint } from '../constants/endpoints';
import BaseController from '../controllers/BaseController';

interface ReportGenerateResponse {
  uri: string;
}

interface ReportRequest {
  raw: string,
  type: {
    mimeType: string
  }
}

class ReportService {
  owner: BaseController;
  patientId: string | number;
  encounterId: string | number;
  nrSequencia!: string | number;
  endpointLista!: string;
  parametrosLista!: Record<string, Value>;

  constructor(owner: BaseController) {
    this.owner = owner;
    this.patientId = owner.context.get('patientId') as string | number;
    this.encounterId = owner.context.get('encounterId') as string | number;

    if (!this.patientId) {
      this.patientId = owner.historyService.getCurrentRouteParams()['nrSeqBeneficiario'] as string;
    }
  }

  openInNewWindow(url: string): void {
    const win = window.open(url, '_blank');
    win && win.focus();
  }

  generateReport(parametrosRelatorio: Record<string, Value>): Promise<string> {
    const body = {
      parameters: parametrosRelatorio,
    };

    const requestParams = { encounterId: this.encounterId, patientId: this.patientId };

    return HttpService.post<ReportGenerateResponse>(Endpoint.POST_REPORT_CONTENT, requestParams, { body })
      .then(response => resolvePath(`${Endpoint.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: response.body?.uri }));
  }

  generateReportImages(parametrosRelatorio: Record<string, Value>): Promise<HttpResponse<unknown>> {
    const body = {
      parameters: parametrosRelatorio,
    };
    const requestParams = { encounterId: this.encounterId, patientId: this.patientId };

    return HttpService.post(Endpoint.POST_REPORT_CONTENT_IMAGES, requestParams, { body });
  }

  getReportImage(path: string): Promise<Record<string, Value>> {
    const route = `${Endpoint.GET_REPORT_IMAGE}?path=${path}`;
    const headers = { accept: 'image/png' };

    return HttpService.fetch<ReportRequest>({
      endpoint: route,
      headers: headers,
      method: HttpMethod.GET
    }).then((response: HttpResponse<ReportRequest>) => {

      if (!response.body) {
        return new Blob()
      }

      const body = response.body
      const byteCharacters = atob(body.raw);
      const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);

      return new Blob([byteArray], { type: body.type.mimeType });

    }).then((blob: Blob) => {
      const src = URL.createObjectURL(blob);

      return ({ src });
    });
  }
}

export default ReportService;
